// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Components
import LineContainer from './LineContainer'

// Shared

export class EmbeddableCartLinesContainer extends Component {
  static displayName = 'EmbeddableCartLinesContainer'

  static propTypes = {
    lines: PropTypes.object,
    hasDates: PropTypes.bool,
    component: PropTypes.any
  }

  render () {
    const { lines, hasDates, component, t } = this.props

    if (lines.size() <= 0) {
      return <div className="bq-clean">{t('user.store.cart_empty')}</div>
    }

    return lines.map((line) => <LineContainer component={component} key={line.id} line={line} hasDates={hasDates} />)
  }
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId)
  const hasDates = !!(cart && cart.starts_at && cart.stops_at)
  const lines = state.orm.lines.getAll({ id: cart != null ? cart.lines : undefined })

  return {
    lines,
    hasDates
  }
}

const reduxComponent = reduxConnect(mapStateToProps, null)(EmbeddableCartLinesContainer)

export default withTranslation('user')(reduxComponent)
